module.exports = __webpack_public_path__ + "img/Puente_Istobal_FLEX5_5_Alto_Blanco-default-front.228769e0.jpg";